<app-header></app-header>
<div class="content_wrapper">
    <div class="add_user">
        <div class="col-md-8">
            <div class="add_form_sec">
                <h4>Edit Project</h4>
                <form [formGroup]="form" (ngSubmit)="edit_project()">
                    <div class="form-group">
                        <label for="username">Project Name</label>
                        <input type="text" id="last_name" name="str_name" class="form-control" formControlName="str_name">
                        <span class="error_message" *ngIf="err.str_name">{{err.str_name}}</span>
                    </div>
                    <div class="form-group" formArrayName="keywords">
                        <label for="username">Keyword & ID</label>
                        <div class="keyword_sec" *ngFor="let keyword of keywords.controls; let keyIndex=index" [formGroupName]="keyIndex">
                            <input placeholder="Keyword" type="text" name="keyword" class="form-control" formControlName="keyword">
                            <input placeholder="ID" type="text" name="id" class="form-control" formControlName="id">
                            <button  title="Remove" type="button" class="btn" (click)="deleteKeyword(keyIndex)"><i class="fa fa-remove"></i></button>
                        </div>
                        <!--{{ this.form.value | json }}-->
                        <span class="error_message" *ngIf="err.alt_keywords">{{err.alt_keywords}}</span>
                    </div>
                    <button class="btn panel_save_btn" type="button" (click)="addKeyword()">Add Keyword</button>
                    <div class="form-group">
                        <label for="username">Language</label>
                        <select formControlName="str_language" class="form-control">
                            <option value="any">Any Languages</option>
                            <option value="en">English</option>
                            <option value="ar">Arabic</option>
                            <option value="hr">Croatian</option>
                            <option value="cs">Czech</option>
                            <option value="da">Danish</option>
                            <option value="nl">Dutch</option>
                            <option value="fi">Finnish</option>
                            <option value="fr">French</option>
                            <option value="de">German</option>
                            <option value="hu">Hungarian</option>
                            <option value="id">Indonesian</option>
                            <option value="it">Italian</option>
                            <option value="ko">Korean</option>
                            <option value="no">Norwegian</option>
                            <option value="pl">Polish</option>
                            <option value="pt">Portuguese</option>
                            <option value="ro">Romanian</option>
                            <option value="ru">Russian</option>
                            <option value="sk">Slovak</option>
                            <option value="es">Spanish</option>
                            <option value="sv">Swedish</option>
                            <option value="th">Thai</option>
                            <option value="tr">Turkish</option>
                            <option value="vi">Vietnamese</option>
                        </select>
                        <span class="error_message" *ngIf="err.str_language">{{err.str_language}}</span>
                    </div>
                    <div class="form-group btn-up">
                        <button class="panel_save_btn">Save</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="rgb(199, 28, 109)" type="square-loader" [fullScreen]="true"></ngx-spinner>
<app-footer></app-footer>
